/* eslint-env browser, es6 */
/**
 * Error codes: E3xxyy
 */
import m from "mithril";

const CSRF_TOKEN = (<HTMLInputElement>(
  document.querySelector('input[name="csrfmiddlewaretoken"]')
)).value;

export interface DuelResult {
  nickname: string;
  words: string[];
  score: number;
}

export interface Duel {
  duelId: string;
  creatorNickname: string;
  boardLetters: string[];
  results: DuelResult[];
}

export interface ApiError {
  message: string;
  code: string;
}

export function createDuel(
  nickname: string,
  boardLetters: string[]
): Promise<Duel> {
  return m
    .request<Duel>({
      method: "POST",
      url: "/webble/api/duels/create",
      body: { nickname, boardLetters },
      headers: {
        "X-CSRFToken": CSRF_TOKEN,
      },
    })
    .catch(handleError);
}

export function saveDuel(
  duelId: string,
  nickname: string,
  score: number,
  words: string[]
): Promise<Duel> {
  return m
    .request<Duel>({
      method: "POST",
      url: "/webble/api/duels/save",
      body: { duelId, nickname, score, words },
      headers: {
        "X-CSRFToken": CSRF_TOKEN,
      },
    })
    .catch(handleError);
}

interface GetDuelResponse {
  duel: Duel | null;
}

export function getDuel(duelId: string): Promise<Duel | null> {
  return m
    .request({
      method: "GET",
      url: `/webble/api/duels/get/${duelId}`,
    })
    .then((response: GetDuelResponse) => {
      return response.duel;
    })
    .catch(handleError);
}

export function getActiveDuel(duelId: string): Promise<Duel | null> {
  return m
    .request({
      method: "GET",
      url: `/webble/api/duels/get-active/${duelId}`,
    })
    .then((response: GetDuelResponse) => {
      return response.duel;
    })
    .catch(handleError);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function handleError(error: any): any {
  if (error.response && error.response.message && error.response.code) {
    throw { message: error.response.message, code: error.response.code };
  } else {
    throw { message: "internal error", code: "E30101" };
  }
}
